import { GET_CARS_DETAILS_SUCCESS, GET_PLAN_DETAILS_SUCCESS } from '../actions';

import { getPlanCarsList, mergeCarDetails } from '../utils/plan';

const initialState = [];

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PLAN_DETAILS_SUCCESS:
      return getPlanCarsList(payload);
    case GET_CARS_DETAILS_SUCCESS:
      return state.map(mergeCarDetails(payload));
    default:
      return state;
  }
};
